import { PackType, ICertificateData } from '@app/certificates/manage/manage';
import { ITranslation } from '@app/shared/interfaces/common-interfaces';
import { IOrder } from '@app/certificates/history/history';
import { InvoiceFormModel } from '@app/certificates/packs/invoice-form/invoice-form';
import { PaymentStatusCode, IPaymentDataPostResponse } from '@app/shared/interfaces/response-interfaces';

export interface IPackData {
    step: OrderStep;
    selectedPackId?: IPackItem['id'];
    selectedCertId?: ICertificateData['certId'];
    invoiceData?: InvoiceFormModel;
    order?: IOrder;
    paymentStatus?: PaymentStatusCode;
    paymentData?: IPaymentDataPostResponse['paymentData'];
    items: IPackItem[];
}

export interface IPackItem {
    id: number;
    packType: PackType;
    name: ITranslation;
    count: number;
    description: ITranslation;
    validityPeriod: number;
    price: number;
    currencyCode: string;
    picture: string;
}

export enum OrderStep {
    LIST,
    REVIEW,
    PAYMENT,
}

export interface IProfilePackItem {
    name: ITranslation;
    type: PackType;
}
